import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import './App.css';

// Redux
import { Provider } from 'react-redux';
import strore from './redux/strore';
import { SET_AUTHENTICATED } from './redux/types';
import { logoutUser, getUserData } from './redux/actions/userActions';

import { lightTheme, darkTheme } from './utils/theme';
import { ThemeContext } from './utils/ThemeContext';

// MUI
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as LegacyThemeProvider } from '@mui/styles';

// Components
import Navbar from './components/layout/Navbar';
import AuthRoute from './utils/AuthRoute';

// Pages
import Home from './pages/home';
import Login from './pages/login';
import Signup from './pages/signup';
import User from './pages/user';

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

const token = localStorage.FBIdToken;
if (token) {
  const decodedToken = jwtDecode(token);
  if (decodedToken.exp * 1000 < Date.now()) {
    window.location.href = '/login';
    strore.dispatch(logoutUser());
  } else {
    strore.dispatch({ type: SET_AUTHENTICATED });
    axios.defaults.headers.common['Authorization'] = token;
    strore.dispatch(getUserData());
  }
}

const getInitialTheme = () => {
  const saved = localStorage.getItem('theme');
  if (saved) return saved === 'dark';
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

function App() {
  const [isDark, setIsDark] = useState(getInitialTheme);
  const theme = createTheme(isDark ? darkTheme : lightTheme);
  const toggleTheme = () => setIsDark(prev => {
    const next = !prev;
    localStorage.setItem('theme', next ? 'dark' : 'light');
    return next;
  });

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LegacyThemeProvider theme={theme}>
          <Provider store={strore}>
            <Router>
              <Navbar />
              <div className="container">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/login" element={<AuthRoute component={Login} />} />
                  <Route path="/signup" element={<AuthRoute component={Signup} />} />
                  <Route path="/users/:handle" element={<User />} />
                  <Route path="/users/:handle/scream/:screamId" element={<User />} />
                </Routes>
              </div>
            </Router>
          </Provider>
        </LegacyThemeProvider>
      </ThemeProvider>
    </ThemeContext.Provider>
  );
}

export default App;
